import { IParticipantInParty, IParty, IUser } from '../../Party';
import {
  IParticipantForUser,
  IPartyForUser,
  TAvailableActions,
  TUserId,
} from '../../PartyClientResponse';

export default class ParticipantActions {
  static getAvailableActions = (
    currentUser: IUser | null,
    participants:
      | { [uid in TUserId]: IParticipantForUser }
      | { [uid in TUserId]: IParticipantInParty },
    party: IPartyForUser
  ): TAvailableActions[] => {
    if (!currentUser) {
      return [];
    }

    const currentUserParticipant = participants[currentUser.uid];

    const actionSet = new Set<TAvailableActions>();
    if (currentUser.isAdmin) {
      actionSet.add('ban');
      actionSet.add('mute-audio');
      actionSet.add('mute-video');
      actionSet.add('make-host');
      actionSet.add('make-moderator');
      actionSet.add('remove-from-room');
    }

    if (
      (currentUserParticipant.tags || []).includes('host') ||
      party.creator === currentUserParticipant.uid
    ) {
      actionSet.add('ban');
      actionSet.add('mute-audio');
      actionSet.add('mute-video');
      actionSet.add('make-host');
      actionSet.add('make-moderator');
      actionSet.add('remove-from-room');
    }

    if ((currentUserParticipant.tags || []).includes('moderator')) {
      actionSet.add('ban');
      actionSet.add('mute-audio');
      actionSet.add('mute-video');
      actionSet.add('make-moderator');
      actionSet.add('remove-from-room');
    }

    return Array.from(actionSet);
  };
}
